<template>
  <div class="view-details" :class="{ 'view-details': true, show: show }">
    <div class="flex flex-v-center flex-h-bet">
      <h3 class="bold blue"></h3>
      <img
        src="/img/circle-x.svg"
        alt="close"
        class="pointer"
        @click="$emit('toggleView')"
      />
    </div>
    <div class="view-details-body mt-20">
      <h3 class="bold">APPROVAL LIST</h3>
      <div class="view-details-items">
        <p class="label">Approval List Name</p>
        <p>{{ leaveApprover.description }}</p>
      </div>
      <div
        class="view-details-items"
        v-if="leaveApprover.category_type !== 'branch'"
      >
        <p class="label">Branch</p>
        <p>{{ leaveApprover.branch && leaveApprover.branch.station_name }}</p>
      </div>
      <div
        class="view-details-items"
        v-if="leaveApprover.category_type === 'station_grade'"
      >
        <p class="label">Grade</p>
        <div>
          <p v-for="grade in leaveApprover.employeeGrades" :key="grade.id">
            {{ grade.grade_name }}
          </p>
        </div>
      </div>
      <div
        class="view-details-items"
        v-if="leaveApprover.category_type === 'branch'"
      >
        <p class="label">Branch</p>
        <div>
          <p v-for="branch in leaveApprover.branches" :key="branch.id">
            {{ branch.station_name }}
          </p>
        </div>
      </div>
      <div
        class="view-details-item"
        v-if="leaveApprover.category_type === 'department'"
      >
        <p class="label">Department</p>
        <div>
          <p v-for="dept in leaveApprover.departments" :key="dept.id">
            {{ dept.department_name }}
          </p>
        </div>
      </div>
      <div
        class="view-details-items"
        v-if="leaveApprover.category_type === 'employees'"
      >
        <p class="label">Employees</p>
        <div>
          <p v-for="employee in leaveApprover.employees" :key="employee.id">
            {{ employee.employee_name }}
          </p>
        </div>
      </div>
      <hr class="hr" />
      <h3 class="bold mt-20">APPROVER DETAILS</h3>
      <div class="view-details-items">
        <p class="label">No. of Approvals</p>
        <p>{{ leaveApprover.no_approvals }}</p>
      </div>
      <div
        class="view-details-items"
        v-for="(item, i) in leaveApprover.approvalLevels"
        :key="item.id"
      >
        <p class="label">Approver Name {{ i + 1 }}</p>
        <p>{{ leaveApprover.approvalLevels[i]["approval_person_name"] }}</p>
        <p class="label">Alt Approver Name {{ i + 1 }}</p>
        <p>{{ leaveApprover.approvalLevels[i]["alt_approval_person"] }}</p>
      </div>
      <div class="view-details-items">
        <p class="label">Approval Type</p>
        <p>{{ leaveApprover.approval_types }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["show", "leaveApprover"],
};
</script>

<style scoped>
.hr {
  width: calc(100% + 40px);
  margin-left: -20px;
  margin-top: 10px;
}
.branch-details-items,
.view-details-item {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  color: #4f4f4f;
  grid-column-gap: 15px;
}
.view-details {
  min-width: 350px;
}
</style>
